import { Check, Close } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { StatusPill } from "../StatusPill";
import { T } from "components/util/t";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles({
    pill: {
        "&&": {
            display: "inline"
        }
    }
});

export const MembershipStatus = ({ membership }) => {
    const classes = useStyles();

    return (
        <Stack direction="row">
            <Typography marginTop={0.25}>{membership.is_member ? <Check fontSize="small" color="success" /> : <Close fontSize="small" color="error" />}</Typography>
            <Typography>
                {membership.series.name}
                {(membership.expired_by_date || membership.expired_by_usage) && <>{" "}<StatusPill status="expired" component="span" className={classes.pill}>
                    <T>{membership.expired_by_usage ? "One-off membership used" : "expired"}</T>
                </StatusPill></>}
            </Typography>
        </Stack>
    );
};
